// extracted by mini-css-extract-plugin
export default {"bufferingContainer":"LypDW__bufferingContainer","loadingSpinner":"zv9YU__loadingSpinner","spin":"h5alb__spin"};